export default __webpack_public_path__ + "static/media/Hustle.cd0140b4.png";